import React, { useState, useEffect } from 'react';
import { getFirestore, collection, query, getDocs } from "@firebase/firestore";
import { app } from '../../firebase.js';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';
import Table from 'react-bootstrap/Table';
import LeftBar from '../../Components/LeftBar';
import Dashnav from '../../Components/Dashnav';

function CourseBySource() {
  const db = getFirestore(app);
  const [chartData, setChartData] = useState([]);
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const q = query(collection(db, 'users'));
      const querySnapshot = await getDocs(q);

      const courseCounts = {};
      const allCourses = new Set();

      querySnapshot.forEach((doc) => {
        const data = doc.data();
        const course = data.course || 'Unspecified';
        const status = data.userStatus || 'Unknown';

        allCourses.add(course);

        if (!courseCounts[course]) {
          courseCounts[course] = {
            applicants: 0,
            converted: 0,
            notConverted: 0
          };
        }

        if (status === 'inactive') {
          courseCounts[course].applicants += 1;
        } else if (['Student', 'Completed', 'Deferred', 'Expelled', 'Dropped'].includes(status)) {
          courseCounts[course].converted += 1;
        } else if (status === 'Did Not Join') {
          courseCounts[course].notConverted += 1;
        }
      });

      // Format for table + chart
      const formatted = Object.keys(courseCounts).map((course) => ({
        course,
        ...courseCounts[course]
      }));

      setChartData(formatted);
      setCourses([...allCourses]);
      setLoading(false);
    };

    fetchData();
  }, [db]);

  return (
    <div className='mainContainer'>
      <LeftBar />
      <div className='theMainContainer'>
        <Dashnav />
        <div className="container mt-4">
          <h4>Course Performance by Status</h4>

          {loading ? (
            <p>Loading...</p>
          ) : (
            <>
              {/* Chart */}
              <div style={{ width: '100%', height: 400 }}>
                <ResponsiveContainer>
                  <BarChart
                    data={chartData}
                    margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="course" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="applicants" stackId="a" fill="#8884d8" name="Applicants" />
                    <Bar dataKey="converted" stackId="a" fill="#82ca9d" name="Converted" />
                    <Bar dataKey="notConverted" stackId="a" fill="#ff6961" name="Did Not Convert" />
                  </BarChart>
                </ResponsiveContainer>
              </div>

              {/* Table */}
              <Table striped bordered hover className="mt-4">
                <thead>
                  <tr>
                    <th>Course</th>
                    <th>Applicants</th>
                    <th>Converted</th>
                    <th>Did Not Convert</th>
                  </tr>
                </thead>
                <tbody>
                  {courses.map((course) => (
                    <tr key={course}>
                      <td>{course}</td>
                      <td>{chartData.find((d) => d.course === course)?.applicants || 0}</td>
                      <td>{chartData.find((d) => d.course === course)?.converted || 0}</td>
                      <td>{chartData.find((d) => d.course === course)?.notConverted || 0}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default CourseBySource;